import APICommon from "@/api/common"
export const apis = {
  product: async (query: any) => {
    const res = await APICommon.getProductList(query)
    if (res.code === 1000) {
      return res.data.products
    }
    return null
  },
  collection: async (query: any) => {
    const res = await APICommon.getCollectionList(query)
    if (res.code === 1000) {
      return res.data.collections
    }
    return null
  },
}
